import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: `${theme.spacing(2)}px 1.5em 0 1.5em`,
  },
  verticalLabel: {
    fontSize: 21,
    marginLeft: 20,
  },
  subtitle: {
    color: theme.palette.secondaryContrast.main,
  },
  paper: {
    color: theme.palette.contrastText.main,
    background: theme.palette.otherElementsBackground.main,
  },
  contrastText: {
    color: theme.palette.contrastText.main,
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
    "& a": {
      textDecoration: "none",
    },
  },
  buttonText: {
    margin: `0 6px 0 ${theme.spacing(1)}px`,
  },
  buttonBackToCart: {
    background: "transparent",
  },
  delivery: {
    margin: theme.spacing(3, 0, 3, 0),
  },
  details: {
    marginTop: theme.spacing(3),
  },
  stripeInput: {
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.separator.main}`,
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(0.5),
  },
  stripeInputError: {
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.alertError.main}`,
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(0.5),
  },
  stripeInputDisabled: {
    opacity: "0.6",
    pointerEvents: "none",
  },
  alert: {
    margin: theme.spacing(3, 0),
  },
  helperText: {
    marginBottom: theme.spacing(2),
    color: theme.palette.contrastText.main,
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    margin: theme.spacing(3, 0),
  },
  modalRoot: {
    width: "600px",
    marginLeft: "auto",
    marginRight: "auto",
    overflow: "hidden",
  },
  warningAlertText: {
    fontSize: 15,
  },
  form: {
    backgroundColor: "transparent",
    color: theme.palette.contrastText.main,
  },
  contentContainer: {
    overflowY: "auto",
  },
}));
